import { SoundSystem } from "../../sounds";
import { Actor } from "../actors/Actor";
import { hitPieces } from "../anims/hitAnimations";
import { AcceptedWordParticle } from "../anims/particles/AcceptedWordParticle";
import { MovedLetterFadeParticle } from "../anims/particles/MovedLetterFadeParticle";
import { ParticleManager } from "../anims/particleSystem";
import Colors from "../Colors";
import EntityManager from "../EntityManager";
import { gameData, getItemsForPosition } from "../GameManager";
import { pickupItem } from "../items/itemUtils";
import {
  countAdjacentOthers,
  piecePos,
  removeLetters,
  WordResult,
} from "../words/wordUtils";

export const playWord = async (
  actor: Actor,
  {
    info,
    freeAction,
    noTriggers,
  }: { info: WordResult; freeAction: boolean; noTriggers: boolean }
) => {
  if (info.word.length === 1) {
    if (info.crosses?.length == 1) {
      info = info.crosses[0];
    } else {
      console.error(
        "Word of length 1 played with unexpected cross:",
        info.crosses
      );
    }
  }
  if (info.pieces) {
    const affectedOwners = new Set<number>(); //Owners 'attacked' by this word being played
    affectedOwners.add;
    actor.x = info.pieces[0].x;
    actor.y = info.pieces[0].y;
    actor.pieceDirection = info.direction;
    const toRemove = actor.pieces.map((p) => p);
    actor.pieces.clear();

    if (info.ownersCovered) {
      info.ownersCovered.forEach(
        (id) => id !== actor.id && affectedOwners.add(id)
      );
    }

    for (const p of info.pieces) {
      if (p.ch) {
        p.ch = actor.breed.isCapital
          ? p.ch.toLocaleUpperCase()
          : p.ch.toLocaleLowerCase();
      }

      p.owner = actor.id;
      p.breed = actor.breed.pieceBreed || p.breed;

      actor.pieces.add(p.id, p);
      if (!gameData.pieces.get(piecePos(p))) {
        gameData.pieces.add(piecePos(p), p);
      }
      ParticleManager.runThenDestroy(
        AcceptedWordParticle,
        p.x,
        p.y,
        p.breed.fg || Colors.WHITE
      );
    }
    toRemove.forEach((next) => {
      if (!actor.pieces.get(next.id)) {
        if (affectedOwners.size > 0) {
          ParticleManager.runThenDestroy(
            MovedLetterFadeParticle,
            next.x,
            next.y,
            { ch: next.ch, fg: next.breed.fg }
          );
        }
        gameData.pieces.remove(piecePos(next));
      }
    });

    actor.spellWand = removeLetters(actor.spellWand, info.word);

    info.crosses?.forEach((c) => {
      if (c.ownersCovered) {
        c.ownersCovered.forEach(
          (id) => id !== actor.id && affectedOwners.add(id)
        );
      }
    });

    if (affectedOwners.size) {
      SoundSystem.play("hit");
    } else {
      SoundSystem.play("move");
    }

    for (const ownerId of affectedOwners) {
      const owner = gameData.actors.get(ownerId);
      if (owner) {
        const survivor = owner.pieces.find(
          (piece) => piece.owner === ownerId && countAdjacentOthers(piece) === 0
        );
        await hitPieces(owner.pieces.asArray(), ownerId, (p) => {
          /**p.end();
          gameData.pieces.remove(piecePos(p));
          owner.pieces.remove(p.id);**/
        });
        owner.health.change(-1);
        owner.aiProps.timid = true;
        if (owner.alive) {
          if (!survivor) {
            if (owner !== gameData.player) {
              EntityManager.removeActorAndPieces(owner);
            } else {
              gameData.freeEntry = true;
            }
          }
        }
      }
    }
  }

  if (actor === gameData.player) {
    gameData.freeEntry = false;
    gameData.noWordTriggers = false;
    info.pieces?.forEach((p) => {
      const items = getItemsForPosition(p.x, p.y);
      items.forEach((item) => {
        if (!item.breed.furniture) {
          pickupItem(actor, item);
          SoundSystem.play("pickup");
        } else if (item.isUsable()) {
          SoundSystem.play("powerup");
          item.useItem(actor);
        }
      });
    });
    gameData.letters = [];
  }

  actor.onEvent("playedWord", { wordInfo: info, freeAction, noTriggers });

  return { valid: true };
};
